module.exports = __webpack_public_path__ + "img/04.9dea0b85.png";